import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const ClarkMachineCard = (props) => {
  return (
    <Link to={props.link} target="_blank" rel="noopener noreferrer">
      <div className="relative flex flex-col p-4 transition-all bg-white border border-solid shadow-md cursor-pointer rounded-xl border-neutral-200 group hover:shadow-2xl">
        <img src={props.imgSrc} alt={props.imgAlt} className="object-contain h-48 transition-all group-hover:scale-105"></img>
        {props.isNew && <div className="absolute top-2 right-2 bg-[#BED701] text-white text-xs font-bold uppercase px-4 py-1.5 rounded-full shadow-md">Novinka</div>}

        <h5 className="mt-4 text-lg text-center ">{props.title}</h5>
        <hr className="h-px border-0 bg-neutral-200" />
        {/* specs grid */}
        <div className="grid grid-cols-2 mt-1 text-sm text-center divide-x divide-y divide-neutral-200 text-neutral-600">
          <div className="py-3">
            <div className="uppercase">Nosnost</div>
            <div className="mt-1 font-semibold text-neutral-800">{props.loadCapacity}</div>
          </div>

          <div className="py-3">
            <div className="uppercase">Pohon</div>
            <div className="mt-1 font-semibold text-neutral-800">{props.drive}</div>
          </div>

          <div className="py-3">
            <div className="uppercase">Výška zdvihu</div>
            <div className="mt-1 font-semibold text-neutral-800">{props.liftHeight}</div>
          </div>

          <div className="py-3">
            <div className="uppercase">Max rychlost</div>
            <div className="mt-1 font-semibold text-neutral-800">{props.maxSpeed}</div>
          </div>

          {props.additionalInfo && (
            <div className="col-span-2 py-3">
              <div className="text-black uppercase">{props.additionalInfo}</div>
            </div>
          )}

          {props.sameHeightAsIfAdditionalInfo && <div className="col-span-2 h-11"></div>}
        </div>
        <hr className="h-px border-0 bg-neutral-200" />

        <Button variant="contained" className="w-full mx-auto mt-4 font-semibold normal-case rounded-full bg-gradient-to-r from-primaryLinearFrom to-primary">
          Zjistit více
        </Button>
      </div>
    </Link>
  );
};

export default ClarkMachineCard;
